<div class="main-content">
  <div class="container-fluid">
    <div class='row'>
      <div class='col-md-12'>
        <div class='row'>
          <div class="row col-md-12">
            <div class="col-md-2">
              <button mat-raised-button color="primary" (click)="goToOrderList()"
                style="background-color: white;color: #187EB1 !important;margin-top: 2%; margin-bottom: 0%;">
                ← Back to Order List
              </button>
            </div>
            <div class="col-md-10">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class='row'>
      <div class='col-md-12'>
        <div class='card upload-order'>
          <app-progress-bar [progress]="progress" (progressUpdated)="onProgressUpdate($event)"></app-progress-bar>
          <div class="card-body upload-order-body">
            <div class='row'>
              <div class='col-md-5'>
                <div class='row order-scroll'>
                  <div class="col-md-12">
                    <div *ngIf="isRequestor">
                      <mat-form-field class="example-full-width">
                        <mat-label>Organizations *</mat-label>
                        <input id='organization-values' tabindex="9" name='organization-values' type="text" matInput
                          [formControl]="organizationControl" [matAutocomplete]="organizationValuesAuto"
                          (change)='organizationChange()'>
                        <mat-autocomplete id='organization-values-auto' #organizationValuesAuto="matAutocomplete"
                          (optionSelected)="organizationChangeEvent($event)" [displayWith]="displayFnForOrganization">
                          <mat-option *ngFor="let organization of organizationfilteredOptions | async"
                            [value]="organization">
                            {{organization.customerName}}
                          </mat-option>
                        </mat-autocomplete>
                        <mat-error *ngIf="organizationControl.hasError('required')">
                          Organization is <strong>required</strong>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div>
                      <mat-form-field class="example-full-width">
                        <mat-label>Department </mat-label>
                        <input id='department-values' name='department-values' type="text" matInput
                          [formControl]="departmentControl" [matAutocomplete]="departmentValuesAuto"
                          (change)='departmentChange()'>
                        <mat-autocomplete id='department-values-auto' #departmentValuesAuto="matAutocomplete"
                          (optionSelected)="departmentChangeEvent($event)" [displayWith]="displayFn">
                          <mat-option *ngFor="let dept of deptfilteredOptions | async" [value]="dept">
                            {{dept.name}}
                          </mat-option>
                        </mat-autocomplete>
                        <mat-error *ngIf="departmentControl.hasError('required')">
                          Department is <strong>required</strong>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div>
                      <mat-form-field class="example-full-width">
                        <mat-label>Job Type</mat-label>
                        <input id='jobtype-values' type="text" matInput [formControl]="jobtypeControl"
                          [matAutocomplete]="jobtypeValuesAuto" (change)='jobtypeChange()'>
                        <mat-autocomplete id='jobtype-values-auto' #jobtypeValuesAuto="matAutocomplete"
                          [displayWith]="displayFn" (optionSelected)="jobTypeChangeEvent($event.option.value)">
                          <mat-option *ngFor="let jobtype of jobTypefilteredOptions | async" [value]="jobtype">
                            {{jobtype.name}}
                          </mat-option>
                        </mat-autocomplete>
                        <mat-error *ngIf="jobtypeControl.hasError('required')">
                          Job Type is <strong>required</strong>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div>
                      <mat-form-field class="example-full-width">
                        <mat-label>Form Type</mat-label>
                        <input id='formtype-values' type="text" matInput [formControl]="formtypeControl"
                          [matAutocomplete]="formtypeValuesAuto" (change)='formtypeChange()'>
                        <mat-autocomplete id='formtype-values-auto' #formtypeValuesAuto="matAutocomplete"
                          [displayWith]="displayFnForFormTypes"
                          (optionSelected)="formTypeChangeEvent($event.option.value.id)">
                          <mat-option *ngFor="let formtype of formTypefilteredOptions | async" [value]="formtype">
                            {{formtype.formName}}
                          </mat-option>
                        </mat-autocomplete>
                        <mat-error *ngIf="formtypeControl.hasError('required')">
                          Form Type is <strong>required</strong>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div>
                      <mat-form-field class="example-full-width">
                        <mat-label>Authors</mat-label>
                        <input id='author-values' type="text" matInput [formControl]="authorControl"
                          [matAutocomplete]="authorValuesAuto" (change)='authorChange()'>
                        <mat-autocomplete id='author-values-auto' #authorValuesAuto="matAutocomplete"
                          [displayWith]="displayFn" (optionSelected)="authorChangeEvent($event.option.value)">
                          <mat-option *ngFor="let author of authorfilteredOptions | async" [value]="author">
                            {{author.name}}
                          </mat-option>
                        </mat-autocomplete>
                        <mat-error *ngIf="authorControl.hasError('required')">
                          Authors is <strong>required</strong>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div *ngIf="isRequestor">
                      <mat-form-field class="example-full-width">
                        <mat-label>Requestors</mat-label>
                        <input id='requestor-values' type="text" matInput [formControl]="requestorControl"
                          [matAutocomplete]="requestorValuesAuto" (change)='requestorChange()'>
                        <mat-autocomplete id='requestor-values-auto' #requestorValuesAuto="matAutocomplete"
                          [displayWith]="displayFn" (optionSelected)="requestorChangeEvent($event.option.value)">
                          <mat-option *ngFor="let requestor of requestorfilteredOptions | async" [value]="requestor">
                            {{requestor.name}}
                          </mat-option>
                        </mat-autocomplete>
                        <mat-error *ngIf="requestorControl.hasError('required')">
                          Requestor is <strong>required</strong>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div *ngIf="isJurisdiction">
                      <mat-form-field class="example-full-width">
                        <mat-label>Jurisdiction</mat-label>
                        <input id='jurisdiction-values' type="text" matInput [formControl]="jurisdictionControl"
                          [matAutocomplete]="jurisdictionValuesAuto" (change)='jurisdicationChange()'>
                        <mat-autocomplete id='jurisdiction-values-auto' #jurisdictionValuesAuto="matAutocomplete"
                          [displayWith]="displayFn" (optionSelected)="jurisdicationChangeEvent($event.option.value)">
                          <mat-option *ngFor="let jurisdiction of jurisdictionfilteredOptions | async"
                            [value]="jurisdiction">
                            {{jurisdiction.name}}
                          </mat-option>
                        </mat-autocomplete>
                        <mat-error *ngIf="jurisdictionControl.hasError('required')">
                          jurisdiction is <strong>required</strong>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div *ngIf="isCourtLocation">
                      <mat-form-field class="example-full-width">
                        <mat-label>Court Location</mat-label>
                        <input id='courtLocation-values' type="text" matInput [formControl]="courtLocationControl"
                          [matAutocomplete]="courtLocationValuesAuto" (change)='courtLocationChange()'>
                        <mat-autocomplete id='courtLocation-values-auto' #courtLocationValuesAuto="matAutocomplete"
                          [displayWith]="displayFn" (optionSelected)="courtLocationChangeEvent($event.option.value)">
                          <mat-option *ngFor="let courtLocation of courtLocationfilteredOptions | async"
                            [value]="courtLocation">
                            {{courtLocation.name}}
                          </mat-option>
                        </mat-autocomplete>
                        <mat-error *ngIf="courtLocationControl.hasError('required')">
                          Court Location is <strong>required</strong>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div *ngIf="isCourtRoom">
                      <mat-form-field class="example-full-width">
                        <mat-label>Court Room</mat-label>
                        <input id='courtRoom-values' type="text" matInput [formControl]="courtRoomControl"
                          [matAutocomplete]="courtRoomValuesAuto" (change)='courtRoomChange()'>
                        <mat-autocomplete id='courtRoom-values-auto' #courtRoomValuesAuto="matAutocomplete"
                          [displayWith]="displayFn" (optionSelected)="courtRoomChangeEvent($event.option.value)">
                          <mat-option *ngFor="let courtRoom of courtRoomfilteredOptions | async" [value]="courtRoom">
                            {{courtRoom.name}}
                          </mat-option>
                        </mat-autocomplete>
                        <mat-error *ngIf="courtRoomControl.hasError('required')">
                          Court Room is <strong>required</strong>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="row" style="margin-top: 5px;" *ngIf="isOrderType">
                        <div class='col-md-6'>
                          <mat-form-field class="example-full-width">
                        <mat-label>Order Type</mat-label>
                        <input id='orderType-values' type="text" matInput [formControl]="orderTypeControl"
                          [matAutocomplete]="orderTypeValuesAuto" (change)='orderTypeChange()'>
                        <mat-autocomplete id='courtRoom-values-auto' #orderTypeValuesAuto="matAutocomplete"
                          [displayWith]="displayFnFororderType" (optionSelected)="orderTypeChangeEvent($event.option.value)">
                          <mat-option *ngFor="let orderType of orderTypefilteredOptions | async" [value]="orderType">
                            {{orderType.name}}
                          </mat-option>
                        </mat-autocomplete>
                        <mat-error *ngIf="orderTypeControl.hasError('required')">
                          Order Type is <strong>required</strong>
                        </mat-error>
                      </mat-form-field>
                        </div>
                        <div class='col-md-6'>
                          <div>
                              <label class="ml-1 font-gray-shade">Order Date</label>
                              <jqxDateTimeInput #myOrderDateTimeInput (onValueChanged)="onOrderDateValueChanged($event)"
                                aria-required="true" [min]="orderDateMin" required [theme]="'material'"  [width]="'95%'" aria-hidden="true"
                                [formatString]="'MMMM-dd-yyyy'">
                              </jqxDateTimeInput>
                              <mat-error *ngIf="orderTypeControl.hasError('required')">
                          Order Date is <strong>required</strong>
                        </mat-error>
                            </div>

                            
                        </div>
                      </div>
                    <form [formGroup]='orderCreationForm'>
                      <div class="row" style="margin-top: 5px;">
                        <div class='col-md-6'>
                          <mat-form-field class="example-full-width">
                            <mat-label>Case Number</mat-label>
                            <input matInput formControlName="caseNumber" required type='text'>
                            <mat-error *ngIf="isValid('caseNumber', 'required')">
                              Case Number is <strong>required</strong>
                            </mat-error>
                          </mat-form-field>
                        </div>
                        <div class='col-md-6'>
                          <mat-form-field class="example-full-width">
                            <mat-label>Language</mat-label>
                            <input matInput formControlName="language" type='text'>
                          </mat-form-field>
                        </div>
                      </div>
                      <div>
                        <div class="row" style="margin-top: 5px;">
                          <div class='col-md-6'>
                            <div>
                              <label class="ml-1 font-gray-shade">Hearing Date</label>
                              <jqxDateTimeInput #myDateTimeInput (onValueChanged)="onValueChanged($event)"
                                aria-required="true" required [theme]="'material'" [width]="'95%'" aria-hidden="true"
                                [formatString]="'MMMM-dd-yyyy'">
                              </jqxDateTimeInput>
                            </div>
                          </div>

                          <div class='col-md-6'>
                            <div>
                              <mat-checkbox formControlName="ishighPriority">High Priority</mat-checkbox>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div *ngIf="showRecordingTimes">
                        <div class="row" style="margin-top: 20px;">
                          <div class='col-md-6'>
                            <div class="col-md-12" style="margin-left: -6%; margin-bottom: 6%;">
                              <div>
                                <mat-label class="ml-1 font-gray-shade">Recording Times</mat-label>
                              </div>
                            </div>
                            <div class="col-md-12 time-inputs">
                              <div class="col-md-4"> <label>Start:</label></div>
                              <div class="col-md-8 time-buttons">
                                <jqxDateTimeInput #startDateTime [width]="80" [height]="25" [formatString]="'HH:mm'"
                                  [showCalendarButton]="false" [showTimeButton]="false">
                                </jqxDateTimeInput>
                              </div>
                            </div>
                            <div class="col-md-12 time-inputs">
                              <div class="col-md-4"><label>End:</label></div>
                              <div class="col-md-8 time-buttons">
                                <jqxDateTimeInput #endDateTime [width]="80" [height]="25" [formatString]="'HH:mm'"
                                  [showCalendarButton]="false" [showTimeButton]="false">
                                </jqxDateTimeInput>
                              </div>
                            </div>
                            <div class="col-md-12 time-inputs">
                              <div class="col-md-4"></div>
                              <div class="col-md-8 time-buttons">
                                <div>
                                  <img src="../../../assets/img/icon/add.png" alt="info" title="Add TimeRange"
                                    class="user-listicon leftpadding" (click)="addTimeRange()"
                                    [hidden]="isEditTimeMode" />
                                  <img src="../../../assets/img/icon/edit.png" alt="info" title="Edit TimeRange"
                                    class="user-listicon leftpadding" (click)="editTimeRange()"
                                    [hidden]="isEditTimeMode" />
                                  <img src="../../../assets/img/icon/update.png" alt="info" title="Update TimeRange"
                                    class="user-listicon leftpadding" (click)="updateTimeRange()"
                                    [hidden]="!isEditTimeMode" />
                                  <img src="../../../assets/img/icon/delete.png" alt="info" title="Delete TimeRange"
                                    class="user-listicon leftpadding" (click)="deleteTimeRange()" />
                                  <img src="../../../assets/img/icon/clear.png" alt="info" title="Cancel"
                                    class="user-listicon leftpadding" *ngIf="isEditTimeMode" (click)="cancelEdit()" />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class='col-md-6'>
                            <div class="listbox-card mt-2">
                              <jqxListBox #timeList [height]="'125px'" [width]="'100%'" [source]="timeListSource"
                                displayMember="label" valueMember="value" [allowDrop]="true" [allowDrag]="true"
                                (onSelect)="onTimeSelect($event)" (onDragEnd)="handleReorder()">
                              </jqxListBox>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>

                  </div>
                </div>
              </div>
              <mat-divider [vertical]="true"></mat-divider>
              <div class='col-md-6' style="margin-left: 2%;">
                <p class="header-text-2">Form details:</p>
                <hr>
                <div class='row order-scroll'>
                  <div class='col-md-12' style="margin-top: 1%;">
                    <form [formGroup]="FormFieldsGroup" *ngIf="showFormFields">
                      <div class="form-row" *ngFor="let field of formfieldsList">
                        <!-- DROPDOWN -->
                        <mat-form-field *ngIf="field.fieldType == 'dropdown'" class="example-full-width">
                          <mat-label>{{ field.displayLabel }}</mat-label>
                          <mat-select [formControlName]="field.propertyName" [required]="field.mandatory">
                            <mat-option *ngFor="let opt of field.options" [value]="opt.Name">
                              {{ opt.Name }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>

                        <!-- CHECKBOX (Moved outside) -->
                        <mat-checkbox *ngIf="field.fieldType == 'checkbox'" [formControlName]="field.propertyName"
                          [required]="field.mandatory">
                          {{ field.displayLabel }}
                        </mat-checkbox>

                        <!-- TEXTBOX -->
                        <mat-form-field *ngIf="field.fieldType == 'textbox' && field.visible"
                          class="example-full-width">
                          <mat-label>{{ field.displayLabel }}</mat-label>
                          <input matInput [formControlName]="field.propertyName" [required]="field.mandatory"
                            maxlength="128">
                        </mat-form-field>

                        <!-- DATEPICKER (Fixed structure) -->
                        <div *ngIf="field.fieldType === 'datepicker'" class="example-full-width">
                          <label>{{ field.displayLabel }}</label>
                          <jqxDateTimeInput #myDateTimeInput aria-required="true" aria-hidden="true"
                            [theme]="'material'" [formControl]="FormFieldsGroup.get(field.propertyName)"
                            [width]="'200px'" [formatString]="'MMMM-dd-yyyy'">
                          </jqxDateTimeInput>
                        </div>
                        <!-- ERROR MESSAGE (Works for all fields) -->
                        <mat-error *ngIf="isValidFormFieldsGroup(field, 'required')">
                          {{ field.displayLabel }} is <strong>required</strong>
                        </mat-error>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class='row mt-2'>
          <div class="col-md-8">
            <div *ngIf="!isEditMode">
              <button [disabled]='sendOrderToNSWCheck' type="button" class="btn btn-outline-primary upload-btn-1 ml-2 mr-1" (click)="selectMediaFiles()">
                <img class="img-upload mr-1" src="../../../assets/img/icon/upload-btn.png" title="Select Media files"
                  style="height: 95%;" />
                Select audio/video
                <span class="position-absolute top-0 start-100 translate-middle badge badge-success file-count-badge">{{
                  getListOfAudioFiles()}}</span>
              </button>
              <button [disabled]='sendOrderToNSWCheck' type="button" class="btn btn-outline-primary upload-btn-1 ml-1 mr-1" (click)="attachDocuments()">
                <img class="img-upload mr-1" src="../../../assets/img/icon/attachment-btn.png"
                  title="Attach reference documents" style="height: 95%;" />
                Supporting Files
                <span class="position-absolute top-0 start-100 translate-middle badge badge-success file-count-badge">{{
                  getListOfAttachmentFiles()}}</span>
              </button>
              <button type="button" class="btn btn-outline-primary upload-btn-1 ml-1 mr-1" (click)="addNotes()">
                <img class="img-upload mr-1" src="../../../assets/img/icon/add-notes-btn.png"
                  title="Fill in the notes" />
                Add Notes
                <span *ngIf="isNotes()"
                  class="position-absolute top-0 start-100 translate-middle badge badge-success notes-badge">
                  <i class="material-icons-outlined" style="font-size: 10px; font-weight: 500;">done</i>
                </span>
              </button>
              <button type="button" class="btn btn-outline-primary upload-btn-1 ml-1 mr-1"
                [disabled]='!isshowEstimation' (click)="calculateEstimate()">
                <img class="img-upload mr-1" src="../../../assets/img/icon/cost_estimation.png" title="Estimate"
                  style="height: 95%;" />
                Get Estimate
                <span *ngIf="isEstimate()"
                  class="position-absolute top-0 start-100 translate-middle badge badge-success notes-badge">
                  <i class="material-icons-outlined" style="font-size: 10px; font-weight: 500;">done</i>
                </span>
              </button>
            </div>
          </div>
          <div class="col-md-4">
            <!-- <div class="col-md-3 btn-upload" style="margin-left: 75%;"> -->
            <button type="button" [disabled]='!canUpload' class="btn btn-outline-primary upload-btn-2 pull-right mr-2"
              style="padding: 12px 20px;" (click)="createOrder('Submit')">
              <img class="img-upload mr-1" src="{{ getUploadIcon() }}" />
              Submit</button>
            <div *ngIf="ShowSaveButton">
              <button type="button" [disabled]='sendOrderToNSWCheck' class="btn btn-outline-primary upload-btn-2 pull-right mr-2"
                style="padding: 12px 20px;" (click)="createOrder('save')">
                <img class="img-upload mr-1" src="{{ getUploadIcon() }}" title="save order " />
                Save</button>
            </div>
            <!-- <div *ngIf="!isEditMode"> -->
            <button type="button" [disabled]='!canUpload' class="btn btn-outline-primary upload-btn-2 pull-right mr-2"
              style="padding: 12px 20px;" (click)="clear()">
              <img class="img-upload mr-2" src="../../../assets/img/icon/clear-btn.png" title="clear order " />
              Clear
            </button>
            <!-- </div> -->
            <!-- <div *ngIf="isEditMode">
              <button type="button" [disabled]='!canUpload' class="btn btn-outline-primary upload-btn-2 pull-right mr-2"
                (click)="cancel()">
                <img class="img-upload mr-2" src="../../../assets/img/icon/clear.png" title="cancel order " />
              cancel
              </button>
            </div> -->
            <!-- </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<jqxNotification #msgNotification [position]="'top-right'" [opacity]="1.0" [autoOpen]="false" [autoClose]="true"
  [animationOpenDelay]="800" [autoCloseDelay]="5000" template.success>
</jqxNotification>